import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuButton } from 'core/elements';
import { Color, Variant } from 'theme/enums';

import { QuotesDashboardQuoteType } from './enums';

interface IProps {
  onChange: (value: QuotesDashboardQuoteType) => void;
  value: QuotesDashboardQuoteType;
}

export const QuoteTypeFilter = ({ onChange, value }: IProps) => {
  const { t } = useTranslation();

  const labelMap = useMemo(
    () => ({
      [QuotesDashboardQuoteType.CUSTOMER]: t('labelCustomerQuotesAndOrders'),
      [QuotesDashboardQuoteType.VENDOR]: t('labelVendorQuotesAndOrders'),
    }),
    [t]
  );

  const menuItems = useMemo(
    () => [
      {
        label: labelMap[QuotesDashboardQuoteType.CUSTOMER],
        onClick: () => onChange(QuotesDashboardQuoteType.CUSTOMER),
        selected: value === QuotesDashboardQuoteType.CUSTOMER,
      },
      {
        label: labelMap[QuotesDashboardQuoteType.VENDOR],
        onClick: () => onChange(QuotesDashboardQuoteType.VENDOR),
        selected: value === QuotesDashboardQuoteType.VENDOR,
      },
    ],
    [labelMap, onChange, value]
  );

  return (
    <MenuButton
      color={Color.NEUTRAL}
      label={labelMap[value]}
      menuItems={menuItems}
      variant={Variant.OUTLINED}
    />
  );
};
